import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideos = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0755 9.10978L14.6696 11.3939C15.1101 11.6738 15.1101 12.3262 14.6696 12.6061L11.0755 14.8902C10.6073 15.1877 10 14.8455 10 14.2841L10 9.71588C10 9.1545 10.6073 8.81225 11.0755 9.10978Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.30236 5.33762C4.72769 5.52899 3.51922 6.68721 3.29771 8.21659C3.13323 9.35223 3 10.6814 3 12C3 13.3186 3.13323 14.6478 3.29771 15.7834C3.51922 17.3128 4.72769 18.471 6.30236 18.6624C7.78212 18.8422 9.72816 19 12 19C14.2718 19 16.2179 18.8422 17.6976 18.6624C19.2723 18.471 20.4808 17.3128 20.7023 15.7834C20.8668 14.6478 21 13.3186 21 12C21 10.6814 20.8668 9.35223 20.7023 8.21658C20.4808 6.68721 19.2723 5.52899 17.6976 5.33762C16.2179 5.15779 14.2718 5 12 5C9.72815 5 7.78211 5.15779 6.30236 5.33762Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6
		})
	]
});
const ForwardRef = forwardRef(SvgVideos);
export { ForwardRef as ReactComponent };
